import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withUser } from "../Contexts/user";
import { FaArrowLeft, FaEdit, FaSave, FaTimes } from "react-icons/fa";
import queries from "../helpers/queries";
import { useMutation } from "@apollo/react-hooks";
const Portfolio = withRouter(({ user, history }) => {
    const defaultProfileImage = "https://venti-fans.com/wp-content/uploads/2025/03/avatar_DmSKRB3ql.webp";
    const portfolioText = user.auth.portfolio || "";
    const [isEditing, setIsEditing] = useState(false);
    const [editedPortfolio, setEditedPortfolio] = useState(portfolioText);
    
    const portfolioSentences = portfolioText.split('\n');
    
    const handleEditClick = () => {
        setIsEditing(true);
        setEditedPortfolio(portfolioText);
    };

    const [editUserPortfolio] = useMutation(queries.EDIT_USER_PORTFOLIO);
    
    const handleSaveClick = async () => {
        const result = await editUserPortfolio({
            variables: {
                portfolio: editedPortfolio,
                userId: user.auth.userId,
            },
        });

        if (result.error) {
            alert("Failed");
        }

        if (result.data) {
            user.auth.portfolio = editedPortfolio;
            setIsEditing(false);
        }     
    };
    
    const handleCancelClick = () => {
        setIsEditing(false);
        setEditedPortfolio(portfolioText);
    };

    return (
        <div className="lg:flex">
            <div className="w-full team-card portfolio-page">
                <h1 className="team-title portfolio-page-breadcrumb">
                    PROFILE &gt; PORTFOLIO
                </h1>
                <div className="portfolio-wrapper">
                    <div className="portfolio-container">
                        <div className="portfolio-image-container">
                            <button
                                type="button"
                                className="namecard-back-btn"
                                onClick={() => history.goBack()}
                                aria-label="Go back"
                            >
                                <FaArrowLeft aria-hidden />
                                Back
                            </button>
                            <img 
                                src={user?.auth?.image || defaultProfileImage} 
                                alt={user?.auth?.name || "User profile"} 
                                className="portfolio-profile-image"
                            />
                        </div>
                        
                        <div className="portfolio-details">
                            <div className="portfolio-content">
                                <div className="portfolio-header">
                                    <h3 className="portfolio-section-title">Portfolio Details</h3>
                                    {isEditing ? (
                                        <div className="portfolio-edit-actions">
                                            <button onClick={handleSaveClick} className="portfolio-edit-btn save">
                                                <FaSave /> Save
                                            </button>
                                            <button onClick={handleCancelClick} className="portfolio-edit-btn cancel">
                                                <FaTimes /> Cancel
                                            </button>
                                        </div>
                                    ) : (
                                        <button onClick={handleEditClick} className="portfolio-edit-btn">
                                            <FaEdit /> Edit
                                        </button>
                                    )}
                                </div>
                                
                                {isEditing ? (
                                    <textarea 
                                        className="portfolio-textarea"
                                        value={editedPortfolio}
                                        onChange={(e) => setEditedPortfolio(e.target.value)}
                                        rows={15}
                                        placeholder="Enter your portfolio details here..."
                                    />
                                ) : (
                                    portfolioSentences.length > 0 ? (
                                        portfolioSentences.map((sentence, index) => (
                                            <p key={index} className="portfolio-text">{sentence}</p>
                                        ))
                                    ) : (
                                        <p className="portfolio-text">No portfolio information available. Click the edit button to add your portfolio details.</p>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default withUser(Portfolio);
